import {
  BikeIcon,
  CameraIcon,
  CarIcon,
  FlagIcon,
  GiftIcon,
  GlassesIcon,
  HammerIcon,
  NotebookPenIcon,
  PenToolIcon,
  RecycleIcon,
  ShirtIcon,
  ShoppingBagIcon,
  SprayCanIcon,
  UsbIcon,
  WatchIcon,
  WineIcon,
} from "lucide-react";
import type { Category } from "../types/configurator";

export const categories: Category[] = [
  { id: "textile-bio", name: "Textile Bio", icon: ShirtIcon, accent: "rose", markings: ["serigraphie", "broderie", "transfert"] },
  { id: "bagagerie", name: "Bagagerie & Maroquinerie", icon: ShoppingBagIcon, accent: "mint", markings: ["serigraphie", "broderie", "transfert", "debossage"] },
  { id: "reutilisable", name: "Je suis réutilisable", icon: RecycleIcon, accent: "rose", markings: ["gravure-laser", "serigraphie", "numerique"] },
  { id: "made-in-france", name: "Made in France", icon: FlagIcon, accent: "mint", markings: ["serigraphie", "broderie", "gravure-laser", "numerique"] },
  { id: "accessoires", name: "Accessoires", icon: GlassesIcon, accent: "rose", markings: ["tampographie", "gravure-laser", "numerique"] },
  { id: "ecriture", name: "Écriture", icon: PenToolIcon, accent: "mint", markings: ["tampographie", "gravure-laser", "numerique"] },
  { id: "bureau", name: "Bureau", icon: NotebookPenIcon, accent: "rose", markings: ["numerique", "debossage", "tampographie"] },
  { id: "high-tech", name: "High Tech", icon: UsbIcon, accent: "mint", markings: ["gravure-laser", "tampographie", "numerique"] },
  { id: "gastronomie", name: "Gastronomie", icon: WineIcon, accent: "rose", markings: ["numerique", "gravure-laser"] },
  { id: "horlogerie", name: "Horlogerie", icon: WatchIcon, accent: "mint", markings: ["gravure-laser", "numerique"] },
  { id: "sante", name: "Santé & Beauté", icon: SprayCanIcon, accent: "rose", markings: ["tampographie", "numerique"] },
  { id: "luxe", name: "Luxe", icon: CameraIcon, accent: "mint", markings: ["gravure-laser", "debossage", "broderie"] },
  { id: "automobile", name: "Automobile", icon: CarIcon, accent: "rose", markings: ["tampographie", "numerique", "gravure-laser"] },
  { id: "outillage", name: "Outillage", icon: HammerIcon, accent: "mint", markings: ["gravure-laser", "tampographie"] },
  { id: "cadeaux", name: "Cadeaux d'affaires", icon: GiftIcon, accent: "rose", markings: ["numerique", "gravure-laser", "debossage"] },
  { id: "sport", name: "Sport, Loisirs & Plein Air", icon: BikeIcon, accent: "mint", markings: ["serigraphie", "broderie", "tampographie", "numerique"] },
];
